import React from "react";
import { projects } from "../data/projectData.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Work = () => {
  const settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 2500,

    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          autoplay: true,
          speed: 800,
          autoplaySpeed: 2500,
        },
      },
    ],
  };
  return (
    <section
      name="work"
      id="work"
      className="w-full md:h-screen text-gray-300 bg-[#0a192f] py-10"
    >
      <div className="max-w-[1150px] mx-auto p-4 flex flex-col justify-center h-full mt-5">
        <div className="text-center">
          <h3 className="text-4xl font-bold inline text-gray-300">
            My <span className="text-primary-color">Projects</span>
          </h3>
          <p className="py-6">Check out some of my awesome work!</p>
        </div>

        {/* container for projects */}
        <div className="p-5">
          <Slider {...settings}>
            {projects.map((item) => (
              <div className="bg-slate-700 rounded-lg p-3" key={item.id}>
                <div className="text-center font-semibold text-xl m-4 hover:border-primary-color hover:border-b-4">
                  {item.name}
                </div>
                <div
                  className="bg-gradient-to-r from-black to-slate-400 shadow-lg shadow-[#040c16] container
                flex justify-center text-center items-center mx-auto duration-200 hover:scale-105 rounded-lg"
                >
                  <a href={item.live} target="_blank" rel="noreferrer">
                    <img
                      className="rounded-lg h-64 object-fill"
                      src={item.image}
                      alt="project"
                    />
                  </a>
                </div>
                <div className="flex justify-center items-center">
                  <a href={item.github} target="_blank" rel="noreferrer">
                    <button className="w-1/2 px-6 m-4 italic duration-200 hover:scale-125 hover:text-primary-color">
                      Code
                    </button>
                  </a>
                  <a href={item.live} target="_blank" rel="noreferrer">
                    <button className="w-1/2 px-6 m-4 italic duration-200 hover:scale-125 hover:text-primary-color">
                      Demo
                    </button>
                  </a>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Work;

/*
style={{ backgroundImage: `url(${item.image})` }}

//Hover effect for images (add after the img tag)
<div className="opacity-0 group-hover:opacity-100 ">
  <span className="text-2xl font bold text-white tracking-wider ">
    {item.name}
  </span>
  <div className="pt-8 text-center ">
    <a href={item.github} target="_blank" rel="noreferrer">
      <button
        className="text-center rounded-lg px-4 py-3 m-2
        bg-white text-gray-700 font-bold text-lg"
      >
        Code
      </button>
    </a>
    <a href={item.live} target="_blank" rel="noreferrer">
      <button
        className="text-center rounded-lg px-4 py-3 m-2
        bg-white text-gray-700 font-bold text-lg"
      >
        Demo
      </button>
    </a>
  </div>
</div>
*/
